import CategoriesFormContainer from './CategoriesFormContainer';

export default CategoriesFormContainer;
